<template>
  <q-page padding>
    <div class="row q-gutter-sm">
      <div class="col-xs-12 col-sm-8">
        <p class="text-h6 text-weight-bold text-brand-5 texto-titulo">
          Listagem de Catálogos
        </p>
      </div>
    </div>

    <div class="q-mt-xl">
      <div class="row col-12 q-my-lg">
        <span
          class="texto-titulo-tabela q-ml-md text-brand-5 text-subtitle1 text-weight-bold"
        >
          Listagem de Catálogos
        </span>
      </div>
      <q-table
        :columns="columns"
        :rows="listaCatalogos"
        :loading="loading"
        :rows-per-page-options="[0]"
        color="primary"
        class="tabela-tamanho-fixo"
        dense
        table-header-class="bg-accent text-weight-bold"
        flat
        hide-bottom
        :grid="$q.screen.lt.sm"
      >
        <template v-slot:item="props">
          <div class="col-xs-12 col-sm-6 col-md-4 q-mb-md">
            <div class="row card text-grid-table text-brand-5 q-pa-sm">
              <div
                class="row col-12 justify-center items-center justify-between"
              >
                <div class="col-7">
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">ID: </strong>
                    {{ props.row.id }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Código: </strong>
                    {{ props.row.code }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Descrição: </strong>
                    {{ props.row.id }}</span
                  >
                  <span class="row col-12 q-ml-sm q-mt-sm"
                    ><strong class="q-mr-xs">Criado Em: </strong>
                    {{
                      props.row.created_at
                        ?.split(" ")[0]
                        .split("-")
                        .reverse()
                        .join("/")
                    }}</span
                  >
                </div>
                <div class="col-5">
                  <div class="row col-12 justify-around">
                    <div>
                      <div class="q-ml-xs text-bold">EPI</div>
                      <q-btn
                        color="blue-6"
                        round
                        size="sm"
                        icon="add"
                        @click="epis(props.row.id)"
                      />
                    </div>
                    <div>
                      <div class="text-bold">Não EPI</div>
                      <q-btn
                        color="blue-6"
                        round
                        size="sm"
                        class="q-ml-xs"
                        icon="add"
                        @click="naoEpis(props.row.id)"
                      />
                    </div>
                    <div>
                      <div class="text-bold">Todos</div>
                      <q-btn
                        color="blue-6"
                        round
                        size="sm"
                        icon="add"
                        @click="todosProdutos(props.row.id)"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:body-cell-id="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.id }}
          </q-td>
        </template>
        <template v-slot:body-cell-codigo="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.code }}
          </q-td>
        </template>
        <template v-slot:body-cell-descricao="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.description }}
          </q-td>
        </template>
        <template v-slot:body-cell-criadoem="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            <div>
              {{
                props.row.created_at
                  ?.split(" ")[0]
                  .split("-")
                  .reverse()
                  .join("/")
              }}
              <p style="margin: 0 0 0 9px">
                {{ props.row.created_at?.split(" ")[1] }}
              </p>
            </div>
          </q-td>
        </template>
        <template v-slot:body-cell-epis="props">
          <q-td :props="props">
            <q-btn
              color="blue-6"
              round
              size="sm"
              icon="add"
              @click="epis(props.row.id)"
            />
          </q-td>
        </template>
        <template v-slot:body-cell-naoepi="props">
          <q-td :props="props">
            <q-btn
              color="blue-6"
              round
              size="sm"
              icon="add"
              @click="naoEpis(props.row.id)"
            />
          </q-td>
        </template>
        <template v-slot:body-cell-todos="props">
          <q-td :props="props">
            <q-btn
              color="blue-6"
              round
              size="sm"
              icon="add"
              @click="todosProdutos(props.row.id)"
            />
          </q-td>
        </template>
      </q-table>
    </div>
  </q-page>
</template>

<script>
import { onMounted, ref } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

const columns = [
  {
    name: "id",
    label: "ID",
    align: "left",
  },
  {
    name: "codigo",
    label: "Código",
    align: "left",
  },
  {
    name: "descricao",
    label: "Descrição",
    align: "left",
  },
  {
    name: "criadoem",
    label: "Criado Em",
    align: "left",
  },
  {
    name: "epis",
    label: "EPIS",
    align: "center",
  },
  {
    name: "naoepi",
    label: "Não EPI",
    align: "center",
  },
  {
    name: "todos",
    label: "Todos",
    align: "center",
  },
];
export default {
  setup() {
    const store = useStore();
    const router = useRouter();

    let loading = ref(false);
    const listaCatalogos = ref([]);
    const listaUnidadesAssociadas = ref([]);

    const listarCatalogos = async () => {
      listaCatalogos.value = [];
      try {
        loading.value = true;
        const response = await store.dispatch("catalogo/listarCatalogos", {
          per_page: 1000,
        });
        let array = response.data.results.data;
        array.forEach((catalogo) => {
          if (catalogo?.vendors.length > 0) {
            catalogo.vendors.forEach((vendor) => {
              if (
                listaUnidadesAssociadas.value.some((id) => id === vendor.id) &&
                !listaCatalogos.value.some(
                  (catalogoAdicionado) => catalogoAdicionado.id === catalogo.id
                )
              ) {
                listaCatalogos.value.push(catalogo);
                return;
              }
            });
          }
        });
        loading.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const epis = async (id) => {
      router.push({
        name: "catalogo-gestaocatalogo-epis",
        params: { unidadeId: id },
      });
    };

    const naoEpis = async (id) => {
      router.push({
        name: "catalogo-gestaocatalogo-nao-epis",
        params: { unidadeId: id },
      });
    };

    const todosProdutos = async (id) => {
      router.push({
        name: "catalogo-gestaocatalogo-todos-produtos",
        params: { unidadeId: id },
      });
    };

    const listarUnidadeUsuario = async () => {
      try {
        const response = await store.dispatch("org/listarUnidades");
        response.listaUnidades.forEach((unidade) => {
          listaUnidadesAssociadas.value.push(unidade.id);
        });
      } catch (error) {
        console.log(error);
      }
    };

    onMounted(async () => {
      await listarUnidadeUsuario();
      listarCatalogos();
    });

    return {
      columns,
      listarCatalogos,

      loading,
      listaCatalogos,
      listarUnidadeUsuario,
      epis,
      naoEpis,
      todosProdutos,
    };
  },
};
</script>

<style scoped>
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 14px;
    margin-top: 10px;
  }
  .container-inputs {
    margin: 0px 0px 0px 0px;
  }
  .texto-titulo-input {
    font-size: 12px;
    margin: 0px;
  }
  .input {
    font-size: 12px;
  }

  .btn {
    margin: 8px 0px 0px 0px;
    font-size: 12px;
  }
  .texto-titulo-tabela {
    margin: 0px 0px 0px 6px;
    font-size: 12px;
  }
  .card {
    border: 1px solid #707070;
    border-radius: 5px;
  }
  .text-grid-table {
    font-size: 12px;
  }
}
</style>
